import { graphql, useStaticQuery } from 'gatsby';

export default ({ title, pathname, lang }) => {
  const { siteJson } = useStaticQuery(
    graphql`
      query Seo {
        siteJson {
          title
          description
          siteUrl
          image {
            childImageSharp {
              gatsbyImageData(layout: FIXED, width: 1200)
            }
          }
          favicon {
            childImageSharp {
              gatsbyImageData(width: 32)
            }
          }
          twitterUsername
        }
      }
    `,
  );
  return {
    ...siteJson,
    title: title ? `${title} - ${siteJson.title}` : siteJson.title,
    url: `${siteJson.siteUrl}${pathname || ''}`,
    lang: lang || siteJson.lang,
    imageUrl: `${siteJson.siteUrl}${siteJson.image.childImageSharp.gatsbyImageData.images.fallback.src}`,
  };
};
